import { useState } from "react";
import { ApiCall } from "../../../helper/axios";
import { getUserToken } from "../../../helper/commonFunction";
import moment from "moment";

export const getRecentSearch = (setLoadingAPI) => {
    const [data, setData] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const search = async (id) => {
        const userToken = getUserToken();
        try {
            await ApiCall(
                "POST",
                `recentExcursions`,
                {
                    excursion_id: id,
                    userToken: userToken
                },
                {},
                "excursion"
            )
        } catch (e) {
            // non-blocking tracking call — ignore failures
        }
    }

    const getSearch = async () => {
        setLoading(true)
        try {
            // Node proxies WP mostBookedExcursion, overrides prices from our
            // pricing module (user -> group -> global) and drops anything not
            // priced in our module. Response is { statusCode, message, data: [] }.
            const details = await ApiCall("POST", "/excursions/most-booked", {}, {})
            const body = details?.data;
            const unwrapped = body?.statusCode && body?.data ? body.data : body;
            setData(Array.isArray(unwrapped) ? unwrapped : [])
        } catch (e) {
            setError(e?.message ?? "Failed to load popular excursions")
        } finally {
            setLoading(false)
        }
    }

    const animatedSuggestions = [
        "Experience",
        "Theme Park",
        "Burj Khalifa",
        "Dubai",
        "Aquarium",
        "Museum",
    ];

    const faqs = [
        {
            question: 'How do I book an excursion activity?',
            description: `Simply select the type of excursion activity you're interested in (e.g., adventure sports, sightseeing tours, nature hikes), choose your preferred date, location, and the number of people, and then click Search to view available options.`,
        },
        {
            question: 'What types of excursion activities can I book?',
            description: 'We offer a wide range of activities, including sightseeing tours, nature excursions, adventure sports, cultural experiences, and more. Browse through our activity categories to find the best options for you',
        },
        {
            question: 'Can I customize my excursion activity?',
            description: `Yes, many of our excursion activities can be tailored to fit your preferences. Whether you want a private tour, specific destinations, or unique experiences, include your requests and we'll help plan it.`,
        },
        {
            question: 'Are meals included in the excursion activities?',
            description: 'Some activities include meals as part of the experience, while others may offer meals at an additional cost. Check the individual activity details for more information.',
        },
        {
            question: 'Do I need to bring any special equipment for adventure activities?',
            description: `For activities like hiking, kayaking, or other adventure sports, we recommend bringing comfortable clothing, appropriate footwear, and any personal equipment you might need. Some activities provide equipment, but it's always best to check in advance.`,
        },
        {
            question: 'Can I get a group discount for excursion activities?',
            description: 'Yes, we offer group discounts for certain activities. Contact us to inquire about group rates and to confirm eligibility',
        },
    ];


    return {
        search,
        getSearch,
        data,
        loading,
        error,
        animatedSuggestions,
        faqs,
    };
};
